module.exports = __webpack_public_path__ + "static/media/news1-n.436262e7.jpg";